import type { ViewProps } from 'react-native'
import { Icon } from '~/components/icon'
import { useTheme } from '~/hooks'
import * as S from './shipping.styles'

export type ShippingProps =
  | ({ type: 'express' } & Omit<ViewProps, 'style'>)
  | ({ type: 'fixed'; value: string } & Omit<ViewProps, 'style'>)

const Shipping = (props: ShippingProps) => {
  const { type, ...rest } = props
  const isExpressShipping = type === 'express'
  const theme = useTheme()
  return (
    <S.Container {...rest}>
      <Icon
        size="tiny"
        symbol={
          isExpressShipping ? 'rdicon-clock-fast' : 'rdicon-truck-delivery-fast'
        }
        color={
          isExpressShipping
            ? 'colorTextFastdeliveryDefault'
            : 'colorTextSuccessAlternative'
        }
      />
      <S.Title
        numberOfLines={1}
        style={
          isExpressShipping
            ? { color: theme.colorTextFastdeliveryDefault }
            : { color: theme.colorTextSuccessAlternative }
        }
      >
        {isExpressShipping ? 'Entrega rápida' : `Frete fixo ${props.value}`}
      </S.Title>
    </S.Container>
  )
}

export { Shipping }
